var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickupDumpTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f823a744-3fa2-47be-aca2-0aefc096aa57",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a4952b1e-397c-4cf3-b2b6-a28b4948ef9d,.e93703b2-2675-4ba6-b543-0f91496ffe65{fill:none;}.e93703b2-2675-4ba6-b543-0f91496ffe65{clip-rule:evenodd;}.be934353-d11c-498c-91f2-231e5f9d4e2c{clip-path:url(#fc44e091-60ee-4d7c-8660-90383119f30b);}.b2bbc5fb-7fab-419a-9106-3e66339b316b{fill:#b2c3c9;}.b2a4503e-e1c7-4c6a-8ee2-e2cc1cbd1c65{clip-path:url(#b3fbe84b-be1c-44cb-bdee-181059435f67);}.b9b2e1d0-2398-4016-8fd8-cc9371405162{clip-path:url(#aa2c4b26-8962-4ea2-914b-7595588397e0);}.ea776937-b1c8-4697-8ddd-936f7a894b3f{clip-path:url(#e8ba6c0f-9c3d-4823-a3d9-087b6ec272be);}.a73505f8-f13f-4443-9b16-5740f20b4dab{clip-path:url(#b17b0ddb-94fa-4f53-a246-8ccf206a9962);}.b2a4770a-851c-417d-98f3-fc00dd3bea9e{clip-path:url(#becf0df0-480c-4d4b-9bcc-04a1cbf4e121);}.a88ea503-48bc-4877-9e91-7339de0effcd{clip-path:url(#b18de9f6-dcac-4df5-9ee1-432259cfa374);}.a4579a62-8042-49c6-bb4c-98bed4039fe5{clip-path:url(#fe7c24f3-d900-4eb0-a8f2-a98138afad86);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc44e091-60ee-4d7c-8660-90383119f30b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M4.69-5.53a.89.89,0,0,1-.88-.89.89.89,0,0,1,.88-.9.89.89,0,0,1,.89.9A.89.89,0,0,1,4.69-5.53ZM4.69-9A2.52,2.52,0,0,0,2.18-6.42,2.53,2.53,0,0,0,4.69-3.88,2.53,2.53,0,0,0,7.21-6.42,2.53,2.53,0,0,0,4.69-9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b3fbe84b-be1c-44cb-bdee-181059435f67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M12.37-5.53a.89.89,0,0,1-.88-.89.89.89,0,0,1,.88-.9.89.89,0,0,1,.89.9A.89.89,0,0,1,12.37-5.53Zm0-3.43A2.52,2.52,0,0,0,9.86-6.42a2.53,2.53,0,0,0,2.51,2.54,2.53,2.53,0,0,0,2.52-2.54A2.53,2.53,0,0,0,12.37-9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa2c4b26-8962-4ea2-914b-7595588397e0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M18-5.51a.89.89,0,0,1-.88-.9A.88.88,0,0,1,18-7.3a.89.89,0,0,1,.89.89A.89.89,0,0,1,18-5.51Zm0-3.43a2.52,2.52,0,0,0-2.51,2.53A2.52,2.52,0,0,0,18-3.87a2.53,2.53,0,0,0,2.52-2.54A2.52,2.52,0,0,0,18-8.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e8ba6c0f-9c3d-4823-a3d9-087b6ec272be"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "e93703b2-2675-4ba6-b543-0f91496ffe65",
    points: "3.86 3.52 3.86 5.74 9.56 5.74 11.38 13.48 20.1 13.48 21.56 7.48 22.99 7.48 22.99 5.74 11.53 5.74 10.76 3.52 3.86 3.52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b17b0ddb-94fa-4f53-a246-8ccf206a9962"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M6.67,11.75a.28.28,0,0,1-.26.3H1.87a.28.28,0,0,1-.26-.29V11.5a.66.66,0,0,1,0-.28L3.09,8.48a.62.62,0,0,1,.58-.39H6.19c.41,0,.48,0,.48.5Zm15.22,3.59a1,1,0,0,0-.95-.94H8.34a.59.59,0,0,1-.59-.6V7.32a.18.18,0,0,0-.18-.18H3.27a.94.94,0,0,0-.86.57l-2.12,4v0a1,1,0,0,0-.08.38l0,7.55a1,1,0,0,0,1,.95h.14a.18.18,0,0,0,.18-.18,3.18,3.18,0,1,1,6.35,0,.18.18,0,0,0,.18.18H9a.18.18,0,0,0,.18-.18,3.17,3.17,0,0,1,5.87-1.69.17.17,0,0,0,.3,0,3.17,3.17,0,0,1,5.84,1.74.22.22,0,0,1,0,.08,1,1,0,0,0,.71-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "becf0df0-480c-4d4b-9bcc-04a1cbf4e121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M4.69,21.34a.9.9,0,1,1,.89-.9A.89.89,0,0,1,4.69,21.34Zm0-3.44a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,4.69,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b18de9f6-dcac-4df5-9ee1-432259cfa374"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M12.37,21.34a.9.9,0,1,1,.89-.9A.89.89,0,0,1,12.37,21.34Zm0-3.44a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,12.37,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe7c24f3-d900-4eb0-a8f2-a98138afad86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a4952b1e-397c-4cf3-b2b6-a28b4948ef9d",
    d: "M18,21.35a.89.89,0,1,1,.89-.89A.88.88,0,0,1,18,21.35Zm0-3.43a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,18,17.92Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "be934353-d11c-498c-91f2-231e5f9d4e2c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: -2.82,
    y: -13.96,
    width: 15.03,
    height: 15.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b2a4503e-e1c7-4c6a-8ee2-e2cc1cbd1c65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: 4.86,
    y: -13.96,
    width: 15.03,
    height: 15.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "b9b2e1d0-2398-4016-8fd8-cc9371405162"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: 10.53,
    y: -13.94,
    width: 15.03,
    height: 15.08
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "ea776937-b1c8-4697-8ddd-936f7a894b3f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: -1.14,
    y: -1.47,
    width: 29.13,
    height: 19.95
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "a73505f8-f13f-4443-9b16-5740f20b4dab"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: -4.8,
    y: 2.14,
    width: 31.72,
    height: 23.42
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "b2a4770a-851c-417d-98f3-fc00dd3bea9e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: -2.82,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "a88ea503-48bc-4877-9e91-7339de0effcd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: 4.86,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "a4579a62-8042-49c6-bb4c-98bed4039fe5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b2bbc5fb-7fab-419a-9106-3e66339b316b",
    x: 10.53,
    y: 12.92,
    width: 15.03,
    height: 15.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupDumpTruck);
export default __webpack_public_path__ + "static/media/pickup-dump-truck.ff6a1fa155978b051750c72d8b910de9.svg";
export { ForwardRef as ReactComponent };